import React from 'react';

import { institutionLoginsSelectors } from 'app-components/flux/institution-logins';

import type { BoxProps } from '@mui/material/Box';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import Dump from 'components/Dump';
import InstitutionIcon from 'components/InstitutionIcon';
import { useAppSelector } from 'hooks/redux';
import LinkPreview from 'components/LinkPreview';

export type InstitutionItemProps = BoxProps & {
  value?: string | null; // institution login id
  title?: string | null;
};
const InstitutionItem = ({ value, title, ...otherProps }: InstitutionItemProps) => {
  const institutionLogin = useAppSelector((state) =>
    institutionLoginsSelectors.getInstitutionLoginForId(state, value || ''),
  );
  const institution = useAppSelector((state) =>
    institutionLoginsSelectors.getInstitutionForInstitutionLogin(state, value || ''),
  );
  return (
    <Box display='flex' alignItems='center' gap={2} sharedcomponentid={InstitutionItem.name} {...otherProps}>
      {/* the institution might be undefined for some providers (ex. kbb and zillow), so pass the login id since we have it */}
      <InstitutionIcon institutionLoginId={institutionLogin?.id} size='sm' />
      <Box flex={1}>
        <Typography variant='titleMedium' style={{ whiteSpace: 'nowrap' }}>
          {title || institutionLogin?.name || institution?.name}
        </Typography>

        {institution?.url && <LinkPreview href={institution?.url} showFavicon={false} />}
        <Dump obj={institution} />
      </Box>
    </Box>
  );
};
export default InstitutionItem;
